import {React,useEffect,useState} from 'react'
import { toast } from 'react-toastify'
import api from '../../../api/api'

const AboutList = () => {
  const [aboutList, setAboutList] = useState([])
  const [deleteAbout, setDeleteAbout] = useState(false)

useEffect(() => {

api
.get("/info/about-us/descriptions/")
.then((resp)=>{
  setAboutList(resp.data)

})
.catch((err)=>{
  toast.error("Something went wrnog ")
})


}, [deleteAbout])

// useEffect(() => {

//   api
//   .get("/info/about-us/descriptions/")
//   .then((resp)=>{
//     setAboutList(resp.data)
//     console.log("about us ",resp.data)

  
//   })
//   .catch((err)=>{
//     toast.error("Something went wrnog ")
//   })
  
  
//   }, [])


const deleteAboutList=(id)=>{

  api
  .delete(`/info/about-us/descriptions/${id}/`)
  .then((response) => {
    setDeleteAbout(!deleteAbout);
    toast.success("Successfully Deleted")
  })
  .catch((error) => {
    toast.error("Unable to delete");
  });

}



  return (
    <div className='md:px-9 px-3'>
           <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
     About List 
      </h1>


      <div className=' '>
<table  className='w-full overflow-x-auto border-primary-red border-2 text-primary-blue '>
<thead className='border-primary-red border-b-2  tex-lg'>
<tr>
  <td className='w-40 border-r text-center border-primary-blue'>S.N</td>
  <td className='p-3 border-r text-center border-primary-blue'>Title</td>
  <td className='p-3 border-r text-center border-primary-blue'>Description</td>
  <td className='p-3 text-center'>Action</td>
  </tr>
</thead>
<tbody>
  {
    aboutList?.map((item,index)=>{
      return(
        <tr key={index} className='text-center border-b border-primary-red'>
        <td className='p-3 border-r border-primary-blue' >{index+1}</td>
        <td className='p-3 border-r border-primary-blue'>{item.title}</td>
        <td className='p-3  border-r border-primary-blue '>{item.description.slice(0,50)}...</td>
        <td className='flex gap-2 items-center justify-center' >
          {/* <button
          className='bg-primary-red rounded-2xl px-2 py-1 text-white '>Edit </button> */}
          <button onClick={()=>deleteAboutList(item.id)} className='bg-primary-red rounded-2xl px-2 py-1 text-white '>Delete </button>
       
        </td>
      </tr>
      )
    })
  }

</tbody>
</table>


      </div>

    </div>
  )
}

export default AboutList